import React from 'react'
import { Link } from 'react-router-dom'
import { HiHeart, HiStar, HiSparkles, HiEye } from 'react-icons/hi'
import Header from '../components/Header'

const Maggie = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-50 to-blue-50 dark:from-gray-800 dark:to-gray-900 py-16 pt-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Meet Maggie the Magpie
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Our beloved mascot who represents the spirit of community engagement and civic pride.
          </p>
        </div>
      </section>

      {/* Maggie Image Section */}
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
              The Face of CitySeeCityFix
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Maggie embodies everything we stand for: curiosity, community, and the drive to make our cities better places to live.
            </p>
          </div>
          
          <div className="flex justify-center">
            <img
              src="/maggie_with_cam.png"
              alt="Maggie the Magpie with Camera - CitySeeCityFix Mascot"
              className="max-w-full h-auto rounded-lg shadow-2xl"
              style={{ maxHeight: '600px' }}
            />
          </div>
        </div>
      </section>

      {/* Maggie's Story */}
      <section className="py-16 bg-gray-50 dark:bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
              Why a Magpie?
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300">
              Maggie represents the perfect symbol for our mission
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-primary-100 dark:bg-primary-900 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <HiEye className="h-8 w-8 text-primary-600 dark:text-primary-400" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                Keen Observation
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Like magpies, our users are observant citizens who notice the details that make a difference in their communities.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-primary-100 dark:bg-primary-900 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <HiHeart className="h-8 w-8 text-primary-600 dark:text-primary-400" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                Community Care
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Magpies are social birds that care for their community, just like our users who look out for their neighborhoods.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-primary-100 dark:bg-primary-900 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <HiSparkles className="h-8 w-8 text-primary-600 dark:text-primary-400" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                Bright & Intelligent
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Magpies are known for their intelligence and problem-solving abilities, reflecting the smart solutions CitySeeCityFix provides.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Fun Facts */}
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
              Fun Facts About Maggie
            </h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="card">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                <HiStar className="inline h-5 w-5 text-yellow-500 mr-2" />
                The Name
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Maggie was chosen because magpies are known for their distinctive black and white plumage, 
                representing the clear, binary nature of problem identification and resolution.
              </p>
            </div>
            
            <div className="card">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                <HiStar className="inline h-5 w-5 text-yellow-500 mr-2" />
                The Personality
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Maggie is curious, helpful, and always ready to assist citizens in making their 
                communities better places to live, work, and play.
              </p>
            </div>
            
            <div className="card">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                <HiStar className="inline h-5 w-5 text-yellow-500 mr-2" />
                The Mission
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Just as magpies are known for collecting shiny objects, Maggie helps collect 
                valuable information about city issues that need attention.
              </p>
            </div>
            
            <div className="card">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                <HiStar className="inline h-5 w-5 text-yellow-500 mr-2" />
                The Connection
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Maggie serves as a friendly, approachable face for CitySeeCityFix, making civic 
                engagement feel welcoming and accessible to everyone.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-primary-600 to-blue-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Join Maggie's Mission
          </h2>
          <p className="text-xl text-primary-100 mb-8">
            Help Maggie make cities better, one report at a time. Together, we can create 
            cleaner, safer, and more connected communities.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/login"
              className="inline-block bg-white text-primary-600 font-semibold py-3 px-6 rounded-lg text-lg hover:bg-gray-100 transition-colors duration-200"
            >
              Get Started with CitySeeCityFix
            </Link>
            <Link
              to="/"
              className="inline-block border-2 border-white text-white font-semibold py-3 px-6 rounded-lg text-lg hover:bg-white hover:text-primary-600 transition-colors duration-200"
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 dark:bg-gray-900 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <img
                  className="h-8 w-8 rounded-full"
                  src="/maggie_round.png"
                  alt="CitySeeCityFix"
                />
                <span className="ml-3 text-xl font-bold text-white">
                  CitySeeCityFix
                </span>
              </div>
              <p className="text-gray-400">
                The easiest way to report city issues—just one click away.
              </p>
            </div>
            
            <div>
              <h3 className="text-white font-semibold mb-4">For Residents</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/" className="hover:text-white">Home</Link></li>
                <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-semibold mb-4">For Cities</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/cities" className="hover:text-white">Learn More</Link></li>
                <li><Link to="/login" className="hover:text-white">Admin Login</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-semibold mb-4">Connect</h3>
              <p className="text-gray-400">
                <a href="https://api.cityseecityfix.com" className="hover:text-white">
                  API Documentation
                </a>
              </p>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 CitySeeCityFix. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Maggie
